<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">
        {{ $t("Manage") }} {{ $t("Broken") }} {{ $t("Seat") }}
      </div>

      <div class="mt-3 border-bottom">
        <div class="row">
          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    selectedCinema && selectedCinema.cine_id ? 'shift-up' : ''
                  "
                >
                  {{ "Select Cinema" }}
                </label>

                <multiselect
                  id="cine_id"
                  v-model="selectedCinema"
                  :multiple="false"
                  :options="Cinemas"
                  deselect-label="Remove"
                  label="cine_name"
                  name="cine_id"
                  placeholder=""
                  select-label="Select"
                  track-by="cine_id"
                  @remove="onSelectCinema($event)"
                  @select="onSelectCinema($event)"
                >
                </multiselect>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    selectedScreen && selectedScreen.screen_id ? 'shift-up' : ''
                  "
                >
                  {{ "Select Screen" }}
                </label>

                <multiselect
                  id="screen_id"
                  v-model="selectedScreen"
                  :multiple="false"
                  :options="Screens"
                  deselect-label="Remove"
                  label="screen_name"
                  name="screen_id"
                  placeholder=""
                  select-label="Select"
                  track-by="screen_id"
                  @select="onSelectScreen($event)"
                >
                </multiselect>
              </div>
            </div>
          </div>
        </div>

        <div class="row p-0 m-0">
          <div class="col-7 p-0">
            <table
              class="swc-report-table"
              border="1"
              style="table-layout: auto; background: white; zoom: 0.9"
            >
              <thead>
                <tr class="bg-lightprimary ">
                  <th class="bg-lightprimary p-1" style="width: 200px">
                    Seat Reserve Type
                  </th>
                  <th class="bg-lightprimary p-1" style="width: 600px">
                    Seats
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center text-bold p-0 manual_bill_item">
                    Broken Seats
                  </td>
                  <td class="text-left p-0 manual_bill_item">
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          selectedBrokenSeat && selectedBrokenSeat.length
                            ? 'shift-up'
                            : 'text-bold'
                        "
                      >
                        {{ "Select Seat" }}
                      </label>

                      <multiselect
                        id="sl_id"
                        v-model="selectedBrokenSeat"
                        :multiple="true"
                        :options="seatList"
                        deselect-label="Remove"
                        label="sl_seat_name"
                        name="sl_id"
                        placeholder=""
                        select-label="Select"
                        track-by="sl_id"
                        :close-on-select="false"
                        @remove="onRemoveBrokenSeat($event)"
                        @select="onSelectBrokenSeat($event)"
                      >
                      </multiselect>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <button @click="onUpdate" class="btn-blue mt-2">Update</button>
      </div>
    </div>
  </div>
</template>
<script>
  import { CLIENT_NAME } from "@/helper/Role";
  import { mapActions, mapGetters } from "vuex";
  import moment from "moment";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/ReportsService";
  import ReportsServiceV2 from "@/services/ReportsService-v2";
  import CinemasService from "@/services/CinemasService";
  import ScreenService from "@/services/ScreenService";

  import { authenticationService } from "@/services/AuthenticationService";
  export default {
    data() {
      return {
        cinema_id: null,
        selectedCinema: {},
        Cinemas: [],
        Screens: [],
        searchValue: "",
        selectedScreen: {},
        screen_id: null,
        screenDetails: {},
        seatList: [],
        selectedSeat: [],
        seatReserveTypes: [],
        selectedSeatReserveTypeOne: {},
        selectedSeatReserveTypeTwo: {},
        seatsListRowTwo: [],
        selectedBrokenSeat: [],
        selectedRepairedSeat: [],
        tempArray: [],
        previousSeatTypeIdNotMaintedSeat: [],
        brokenSeatsRowOption: [
          {
            srt_id: 13,
          },
        ],
      };
    },
    beforeMount() {
      this.getCinemaList();
      this.getSeatReserveType();
    },
    methods: {
      getCinemaList: function(cine_id) {
        this.Cinemas = [];
        MasterService.GetCinemasByRoles({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema(event) {
        this.selectedCinema = event;
        this.cinema_id = event.cine_id;
        this.getScreenByCinema(event);
      },
      getScreenByCinema(cinema) {
        let body = {
          activekey: "",
          conditionColName: "cinema_id",
          conditionId: cinema.cine_id,
          searchValue: this.searchValue,
          columnName: "screen_name",
          orderBy: "ASC",
          checkNewSeatLayout: true,
        };
        let loader = this.$loading.show();
        CinemasService.GetActiveScreenByCinema(body)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Screens = data.Records.filter((x) => x.screen_is_active);
              this.Screens.sort((a, b) => {
                return a.screen_id - b.screen_id;
              });
            } else {
              // Error Message
              console.log("show error1 :", data.message);
            }
          })
          .catch((error) => {
            console.log("show error2 :", error);
          })
          .finally(() => loader.hide());
      },
      onSelectScreen(event) {
        this.selectedScreen = event;
        this.screen_id = event.screen_id;
        this.getSeatLayout(event);
      },
      getSeatLayout: function(event) {
        this.seats = [];
        this.seatList = [];
        this.selectedBrokenSeat = [];
        this.selectedRepairedSeat = [];
        let payload = {
          screenID: event.screen_id,
        };
        let loader = this.$loading.show();

        ScreenService.getSeatLayout(payload)
          .then((result) => {
            // console.log("result :", result);
            const { data } = result;
            if (data.status && data.Records.screen_layouts.length > 0) {
              this.screenDetails =
                data.Records["screenDetails"] &&
                data.Records.screenDetails.length > 0
                  ? data.Records.screenDetails[0]
                  : this.screenDetails;
              let filterSeats = [];
              if (
                data.Records.screen_layouts &&
                data.Records.screen_layouts.length
              ) {
                filterSeats = data.Records.screen_layouts.filter(
                  (seat) => ![2, 12, 6, 8].includes(seat.seat_reserve_type_id)
                );
                this.selectedBrokenSeat = data.Records.screen_layouts.filter(
                  (seat) => seat.seat_reserve_type_id == 13
                );
                console.log("selectedBrokenSeat=>", this.selectedBrokenSeat);
              }

              this.seatList = filterSeats.reverse();
            } else {
              // SHOW ERROR:
              console.log(
                "data.message || `Please try again` :",
                data.message || `Please try again`
              );
            }
          })
          .catch((err) => {})
          .finally(() => loader.hide());
      },
      getSeatReserveType() {
        let payload = {
          tableName: "ms_seat_reserve_types",
          srt_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              console.log("reserser type 1=>", data.Records);
              let filterReserveType = data.Records.filter(
                (type) => ![2, 12, 6, 8].includes(type.srt_id)
              );
              console.log("reserser type 2=>", filterReserveType);

              this.seatReserveTypes = filterReserveType;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch(this._CatchError);
      },
      onRemoveBrokenSeat(event) {
        if (event.seat_reserve_type_id == 13) {
          this.selectedRepairedSeat.push(event);
        }
        // let Ids=this.selectedRepairedSeat?this.selectedRepairedSeat.map((seat)=>seat.sl_id):[]
        // this.seatList=this.seatList.filter(seat=>!Ids.includes(seat.sl_id))
      },
      onSelectBrokenSeat(event) {
        this.selectedRepairedSeat = this.selectedRepairedSeat.filter(
          (seat) => seat.sl_id !== event.sl_id
        );
      },
      onRemoveRepairedSeat(event) {
        if (event.seat_reserve_type_id == 13) {
          this.selectedBrokenSeat.push(event);
          this.seatList.push(event);
          let arr = this.sortSeats(this.seatList);
          console.log("arr 1=>", arr);
          this.seatList = arr || [];
        }
      },
      sortSeats(seatList) {
        console.log("start");
        let arrr = seatList.sort((a, b) => {
          const regex = /^([A-Za-z]+)(\d+)$/;

          const [, alphaA, numA] = a.sl_seat_name.match(regex);
          const [, alphaB, numB] = b.sl_seat_name.match(regex);

          if (alphaA !== alphaB) {
            return alphaA.localeCompare(alphaB);
          }

          return parseInt(numA) - parseInt(numB);
        });
        return arrr;
      },
      async onUpdate() {
        let finalSeatArray = [];

        this.selectedRepairedSeat.forEach((seat) => {
          let obj = {
            sl_id: seat.sl_id,
            isBroken: "N",
            seatTypeValue: seat.previous_seat_reserve_type_id,
            previousSeatTypeValue: null,
          };
          if (seat.previous_seat_reserve_type_id) {
            finalSeatArray.push(obj);
          } else {
            this.previousSeatTypeIdNotMaintedSeat.push(seat.sl_seat_name),
              this.tempArray.push(seat);
          }
        });

        if (this.previousSeatTypeIdNotMaintedSeat.length) {
          console.log("tempar=>", this.tempArray);
          this.tempArray.forEach((seat) => {
            const seatIndex = this.selectedRepairedSeat.findIndex(
              (existingSeat) => existingSeat.sl_id == seat.sl_id
            );

            if (seatIndex !== -1) {
              this.selectedRepairedSeat.splice(seatIndex, 1);
            }
          });
          this.selectedBrokenSeat.push(...this.tempArray);
          console.log(
            "previousSeatTypeIdNotMaintedSeat=>",
            this.previousSeatTypeIdNotMaintedSeat
          );
          let seatNames = this.previousSeatTypeIdNotMaintedSeat.join(",");
          console.log("this.selectedBrokenSeat", this.selectedBrokenSeat);
          this.tempArray = [];
          this.previousSeatTypeIdNotMaintedSeat = [];
          this.$toasted.show(
            `Seat ${seatNames} not able to update from here,please use seat layout module`
          );
          return;
        }

        this.selectedBrokenSeat.forEach((seat) => {
          let obj = {
            sl_id: seat.sl_id,
            isBroken: "Y",
            seatTypeValue: 13,
          };
          if (seat.seat_reserve_type_id !== 13) {
            obj.previousSeatTypeValue = seat.seat_reserve_type_id;
          }
          finalSeatArray.push(obj);
        });

        let payload = {
          broken_seats: finalSeatArray,
          end_time: "",
          from_time: "",
          is_permanent: "Y",
          screen_id: this.selectedScreen.screen_id,
        };

        let Ids = this.selectedBrokenSeat.map((seat) => seat.sl_id).join(",");

        let res = await ScreenService.checkBookedSeatsForBrokenUpdate({
          screen_id: this.selectedScreen.screen_id,
          seat_layout_id: Ids || "",
        });

        if (res.data && res.data.status && res.data.data.length) {
          console.log("check for seat success =>");
          this.$toasted.show(
            "This seat is already booked, not able to set broken seat"
          );
          return;
        }
        console.log("check for seat success not =>");
        console.log("checkData =>", res.data);

        let loader = this.$loading.show();

        try {
          const response = await ScreenService.manageBrokenSeatLayout(payload);
          console.log("res =>", response.data);

          if (response.data && response.data.status) {
            this.getSeatLayout(this.selectedScreen);
            this.$toasted.show("Seat reserve type updated successfully");
            console.log("Updated successfully");
          } else {
            this.$toasted.show("Seat reserve type update failed");
          }
        } catch (err) {
          console.log(err);
        } finally {
          setTimeout(() => loader.hide(), 1000);
        }
      },
    },
  };
</script>
<style>
  .greyBackground {
    background-color: #e9ecef;
    border-radius: 15px;
  }

  .whiteBackground {
    background-color: white;
    border-radius: 15px;
  }

  .container {
    position: relative;
    padding: 40px;
    margin-top: 30px;
    border: 1px solid var(--blue);
  }

  .heading {
    position: absolute;
    top: -0.5em;
    left: 30px;
    margin: 0;
    background: #fff;
    padding: 0 10px;
    color: var(--blue);
    font-weight: bold;
  }
  .manual_bill_item .multiselect__tags {
    border-radius: unset !important;
    border: unset !important;
    border: 1px solid red;
  }

  .manual_bill_item .multiselect__input {
    border: none !important;
  }

  .manual_bill_item .multiselect {
    border: none !important;
  }
  .bg-lightprimary {
    background-color: #3876d217;
  }

  .manual_bill_input input {
    border: none;
    height: 40px;
    margin: 0;
    width: 100%;
    padding-inline: 10px;
  }

  .manual_bill_input input::placeholder,
  .manual_bill_wrapper .multiselect__placeholder {
    font-size: 12px;
    font-style: italic;
  }
  .text-bold {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemaSeatLayoutComponents/manageBrokenSeat.vue